export function buildColumns(role: string) {
  switch (role) {
    case "SUPERUSER":
      return superuserColumns;

    case "MERCHOLOGIST":
      return merchologistColumns;

    case "ADMIN":
      return adminColumns;

    default:
      return adminColumns;
  }
}

const columns = {
  merchstore: {
    text: "MerchStore",
    class: "text-left",
  },
  customerContact: {
    text: "Customer Contact",
    class: "text-left pl-10",
  },
  merchologyContact: {
    text: "Merchology Contact",
    class: "text-left",
  },
  storeId: {
    text: "Store ID",
    class: "text-left",
  },
  orders: {
    text: "Orders",
    class: "text-center",
  },
  revenue: {
    text: "Revenue"
  },
  close: {
    text: "Close"
  },
  status: {
    text: "Status"
  },
  dropdown: {
    text: ""
  }
}

const merchologistColumns = [
  columns.merchstore,
  columns.customerContact,
  columns.storeId,
  columns.orders,
  columns.revenue,
  columns.close,
  columns.dropdown
]

const adminColumns = [
  columns.merchstore,
  columns.customerContact,
  columns.storeId,
  columns.orders,
  columns.close,
  columns.dropdown
]

const superuserColumns = [
  columns.merchstore,
  columns.customerContact,
  columns.merchologyContact,
  columns.orders,
  columns.revenue,
  columns.close,
  columns.dropdown
]

